module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terminal-modal"
  }, [_c('div', {
    staticClass: "terminal-box animated fadeIn"
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.items.activity.terminal.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.items.activity.terminal.text)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button back",
    on: {
      "click": _vm.tryAgain
    }
  }, [_vm._v(_vm._s(_vm.items.activity.terminal.button))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6656e0fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/components/TerminalModal.vue
// module id = 142
// module chunks = 0